/**
 * @fileoverview Barrel exports for the run-refine-full-v2 COMPOSITE agent.
 *
 * This is a composite agent that orchestrates two primitives in a pipeline:
 * - refine-synthesizer: Creates an editorial brief from ALL findings/weaknesses/strengths
 * - draft-refiner-v2: Refines the chapter based on the editorial brief
 *
 * Unlike run-refine-v2, this processes ALL available items (brute-force mode).
 *
 * Structure:
 * - definition.ts: Agent metadata with composite configuration
 * - schema.ts: Input/output Zod schemas (re-exported from run-refine-v2)
 * - prompt.ts: Placeholder prompt (primitives have their own prompts)
 * - flow.ts: Pipeline orchestration logic using executePipeline
 */

// Agent definition
export { definition } from './definition';

// Schemas and types (re-exported from run-refine-v2)
export {
  InputSchema,
  OutputSchema,
  HookInputSchema,
  FindingSchema,
  WeaknessSchema,
  StrengthSchema,
  type Input,
  type Output,
  type HookInput,
} from './schema';

// Flow
export { flow, runRefineFullV2AgentFlow } from './flow';

